define('sentient/aba/views/PrimeView',[
	'jquery',
	'underscore',
	'backbone',
	'domReady',
	'loglevel',
	'../collections/PrimesCollection'
	], function($, _, Backbone, domReady, log, PrimesCollection) {
		log.trace('running PrimeView.js');
		var PrimeView = Backbone.View.extend({
		 collection: PrimesCollection,
		 el: $('.sentient-aba-session .prime-container'),
		 initialize: function() {
			var size = Math.min(this.$el.width(), this.$el.height());

			var canvas = this.$el.find('canvas').get(0);
			if (!canvas) {
			 canvas = document.createElement('canvas');
		 }

		 canvas.setAttribute('style', 'padding:0;margin:0;');
		 this.$el.append(canvas);
		 this.canvas = canvas;
		 this.canvas.setAttribute('width', size);
		 this.canvas.setAttribute('height', size);
	 },
	 setSize: function(size) {
		var canvasDimension = Math.min(size.width, size.height);
		this.canvas.setAttribute('width', canvasDimension);
		this.canvas.setAttribute('height', canvasDimension);
		this.canvas.setAttribute('style', 'position:absolute;top:' + (~~((size.height / 2) - (canvasDimension / 2))).toString() + 'px;left:' + (~~((size.width / 2) - (canvasDimension / 2))).toString() + 'px;width:' + canvasDimension + 'px;height:' + canvasDimension + 'px');
	},
	render: function() {
	},
	hidePrime: function() {
				//log.debug("hidePrime",this.animation);
				if (this.animation && this.animation.intervalId) {
					clearInterval(this.animation.intervalId);
				}
				if (this.animation && this.animation.ctx) {
					this.animation.ctx.clearRect(0, 0, this.animation.ctx.canvas.width, this.animation.ctx.canvas.height);
				} else {
					var canvas = this.$el.find('canvas').each(function(index, canvas) {
						var ctx = canvas.getContext('2d');
						if (ctx) {
							ctx.clearRect(0, 0, canvas.width, canvas.height);
						}
					});

				}
			},
			displayPrime: function(primeName, doneCallback) {
				var primeModel = this.collection.findWhere({'name': primeName});
				this.currentPrime = primeModel;

				if (!primeModel) {
					log.error('Can not display prime ' + primeName + '. No sutch prime in app prime collection.');
				}
				primeTime = parseInt(this.currentPrime.get('time'), 10);

				if (!primeModel.get('ready')) {
					//log.debug("Attempting to display a prime that has not loaded. Deferring till load is compleate.");
					this.listenToOnce(primeModel, 'change:ready', $.proxy(function(model, value, options) {
						//log.debug("Running deferred displayPrime()");
						if (value) {
							this['view'].displayPrime.apply(this['view'], this['arguments']);
						}
					},
					{'view': this, 'arguments': arguments}));
					return;
				}
				//log.debug("primeModel",primeModel);
				if (this.animation) {
					clearInterval(this.animation.intervalId);
					this.animation = {};
				} else {
					this.animation = {};
				}

				this.animation.StartTime = (new Date()).getTime();
				this.animation.runLength = primeTime;
				this.animation.ctx = this.$el.find('canvas').get(0).getContext('2d');


				this.animation.primeModel = primeModel;
				this.animation.doneCallback = doneCallback;
				var intervalCallback = this.animation.intervalCallback = $.proxy(function() {
					//log.debug("animation.intervalCallback! "+this.animation.intervalId);

					//Setup some local variables.
					var now = (new Date()).getTime(),
					timeElapsed = (now - this.animation.StartTime),
					compleate = timeElapsed / this.animation.runLength,
					ctx = this.animation.ctx;

					//If we are at the end of the animation loop, stop the setInterval()
					if (timeElapsed >= this.animation.runLength) {
						clearInterval(this.animation.intervalId);
						if (this.animation.doneCallback) {
							this.animation.doneCallback();
						}
						delete this.animation;
						return;
					} else if (this.animation.requestAnimationFrame) {
						this.animation.requestAnimationFrame.call(window, function() { intervalCallback(); });
					}
					var startOffsetX = this.animation.primeModel.get('start-offset-x'),
					endOffsetX = this.animation.primeModel.get('end-offset-x'),
					startOffsetY = this.animation.primeModel.get('start-offset-y'),
					endOffsetY = this.animation.primeModel.get('end-offset-y'),
					startWidth = this.animation.primeModel.get('start-width'),
					startHeight = this.animation.primeModel.get('start-height'),
					endWidth = this.animation.primeModel.get('end-width'),
					endHeight = this.animation.primeModel.get('end-height');
					var imageX = ~~(((endOffsetX - startOffsetX) * compleate) + startOffsetX);
					var imageY = ~~(((endOffsetY - startOffsetY) * compleate) + startOffsetY);
					var imageWidth = ~~(((endWidth - startWidth) * compleate) + startWidth);
					var imageHeight = ~~(((endHeight - startHeight) * compleate) + startHeight);

					ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
					ctx.drawImage(primeModel.image, imageX, imageY, imageWidth, imageHeight);
					//ctx.strokeRect(imageX,imageY,imageWidth,imageHeight);
					//log.debug("ctx.drawImage (image," + imageX + "," + imageY+","+imageWidth+","+imageHeight+")");
					//ctx.fillText("ctx.drawImage (image," + parseInt(imageX,10).toString() + "," + parseInt(imageY,10).toString()+","+parseInt(imageWidth,10).toString()+","+parseInt(imageHeight,10).toString()+")" ,10,50);
				},this);

				//This next section of code look to see if we have accsess to requestAnimationFrame.
				this.animation.requestAnimationFrame = null;
				if (typeof window.requestAnimationFrame != 'undefined') {
					this.animation.requestAnimationFrame = window.requestAnimationFrame;
				} else if (typeof window.mozRequestAnimationFrame != 'undefined') {
					this.animation.requestAnimationFrame = window.mozRequestAnimationFrame;
				} else if (typeof window.webkitRequestAnimationFrame != 'undefined') {
					this.animation.requestAnimationFrame = window.webkitRequestAnimationFrame;
				} else if (typeof window.msRequestAnimationFrame != 'undefined') {
					this.animation.requestAnimationFrame = window.msRequestAnimationFrame;
				}
				this.animation.requestAnimationFrame = null;
				if (!this.animation.requestAnimationFrame) {
					//On browsers without requestAnimationFrame we use setInterval at about 30 fps.
					this.animation.intervalId = setInterval(this.animation.intervalCallback, 1000 / 30);
					//log.debug("requestAnimationFrame not found, using setInterval");
				} else {
					//log.debug("this.animation.requestAnimationFrame",this.animation.requestAnimationFrame,window);
					this.animation.requestAnimationFrame.call(window, function() {
						intervalCallback();
					});
				}
			}
		});
return PrimeView;
});

